const PINNED_ATTRIBUTE = 'data-bn-menu-pinned';
let hoverCloseTimer;

function getTopLevelMenuLink(target) {
  if (!(target instanceof Element)) return null;

  const candidateItem = target.closest('header-menu .menu-list__list-item');
  const trigger = target.closest('header-menu .menu-list__list-item > .menu-list__trigger');
  const link =
    trigger?.querySelector(':scope > .menu-list__link') ||
    candidateItem?.querySelector(':scope > .menu-list__trigger > .menu-list__link');
  if (!(link instanceof HTMLAnchorElement)) return null;

  const item = link.closest('.menu-list__list-item');
  if (!item?.querySelector(':scope > .menu-list__submenu')) return null;

  return link;
}

function openPinnedMenu(link, mode) {
  const item = link.closest('.menu-list__list-item');
  const headerMenu = link.closest('header-menu');
  const trigger = item?.querySelector(':scope > .menu-list__trigger > button[aria-controls]');
  const submenu = item?.querySelector(':scope > .menu-list__submenu');
  if (
    !(item instanceof HTMLElement) ||
    !(headerMenu instanceof HTMLElement) ||
    !(trigger instanceof HTMLButtonElement) ||
    !(submenu instanceof HTMLElement)
  ) {
    return false;
  }

  const currentItem = headerMenu.querySelector(`[${PINNED_ATTRIBUTE}]`);
  if (currentItem !== item) closePinnedMenu(headerMenu);
  item.setAttribute(PINNED_ATTRIBUTE, '');
  item.dataset.bnMenuMode = mode;
  const restoreOpenState = () => keepPinnedMenuOpen(headerMenu, item, trigger, submenu);
  restoreOpenState();
  requestAnimationFrame(restoreOpenState);
  setTimeout(restoreOpenState, 100);
  setTimeout(restoreOpenState, 300);
  return true;
}

function closePinnedMenu(headerMenu) {
  const item = headerMenu.querySelector(`[${PINNED_ATTRIBUTE}]`);
  if (!(item instanceof HTMLElement)) return;

  const trigger = item.querySelector(':scope > .menu-list__trigger > button[aria-controls]');
  const submenu = item.querySelector(':scope > .menu-list__submenu');
  item.removeAttribute(PINNED_ATTRIBUTE);
  delete item.dataset.bnMenuMode;
  trigger?.setAttribute('aria-expanded', 'false');
  submenu?.removeAttribute('data-active');
  headerMenu.setAttribute('aria-expanded', 'false');
  headerMenu.style.removeProperty('--submenu-opacity');

  const header = headerMenu.closest('header-component');
  header?.style.removeProperty('z-index');
  header?.removeAttribute('data-bn-menu-compact');
  header?.style.removeProperty('--submenu-height');
  header?.style.removeProperty('--full-open-header-height');
}

function keepPinnedMenuOpen(headerMenu, item, trigger, submenu) {
  if (!item.hasAttribute(PINNED_ATTRIBUTE)) return;

  trigger.setAttribute('aria-expanded', 'true');
  submenu.setAttribute('data-active', '');
  headerMenu.setAttribute('aria-expanded', 'true');
  headerMenu.style.setProperty('--submenu-opacity', '1');

  const header = headerMenu.closest('header-component');
  if (!(header instanceof HTMLElement)) return;

  header.style.setProperty('z-index', '1000', 'important');

  const visibleHeight = header.hasAttribute('data-submenu-overlap-bottom-row')
    ? header.querySelector('.header__row--top')?.getBoundingClientRect().height || 0
    : header.getBoundingClientRect().height;
  const submenuInner = submenu.querySelector('.menu-list__submenu-inner');
  if (submenuInner instanceof HTMLElement) {
    header.removeAttribute('data-bn-menu-compact');
    const availableHeight = window.innerHeight - submenuInner.getBoundingClientRect().top - 8;
    if (submenuInner.scrollHeight > availableHeight) {
      header.setAttribute('data-bn-menu-compact', '');
    }
  }
  const submenuHeight = Math.max(
    submenu.getBoundingClientRect().height,
    submenu.scrollHeight,
    submenuInner?.getBoundingClientRect().height || 0,
    submenuInner?.scrollHeight || 0
  );
  header.style.setProperty('--submenu-height', `${submenuHeight}px`);
  header.style.setProperty('--full-open-header-height', `${visibleHeight + submenuHeight}px`);
}

window.addEventListener(
  'pointerleave',
  (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    if (event.target.matches(`header-menu .menu-list__list-item[${PINNED_ATTRIBUTE}]`)) {
      event.stopImmediatePropagation();
    }
  },
  true
);

document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('header-menu .menu-list__submenu a')) {
    clearTimeout(hoverCloseTimer);
    document.querySelectorAll('header-menu').forEach(closePinnedMenu);
    return;
  }

  const link = getTopLevelMenuLink(event.target);

  if (link) {
    const item = link.closest('.menu-list__list-item');
    const headerMenu = link.closest('header-menu');
    if (!(item instanceof HTMLElement) || !(headerMenu instanceof HTMLElement)) return;

    event.preventDefault();
    const alreadyClickPinned = item.hasAttribute(PINNED_ATTRIBUTE) && item.dataset.bnMenuMode === 'click';
    if (alreadyClickPinned) {
      closePinnedMenu(headerMenu);
      return;
    }

    openPinnedMenu(link, 'click');
    return;
  }

  if (event.target instanceof Element && event.target.closest('header-menu .menu-list__submenu')) return;
  document.querySelectorAll('header-menu').forEach(closePinnedMenu);
});

document.addEventListener('pointerover', (event) => {
  const link = getTopLevelMenuLink(event.target);
  if (link) {
    clearTimeout(hoverCloseTimer);
    const item = link.closest('.menu-list__list-item');
    if (item?.dataset.bnMenuMode !== 'click') openPinnedMenu(link, 'hover');
    return;
  }

  if (!(event.target instanceof Element) || event.target.closest('header-menu')) {
    clearTimeout(hoverCloseTimer);
    restorePinnedMenus();
    return;
  }

  clearTimeout(hoverCloseTimer);
  hoverCloseTimer = setTimeout(() => {
    document
      .querySelectorAll(`header-menu .menu-list__list-item[${PINNED_ATTRIBUTE}][data-bn-menu-mode='hover']`)
      .forEach((item) => {
        const headerMenu = item.closest('header-menu');
        const submenu = item.querySelector(':scope > .menu-list__submenu');
        if (
          headerMenu instanceof HTMLElement &&
          !headerMenu.matches(':hover') &&
          !item.matches(':hover') &&
          !submenu?.matches(':hover')
        ) {
          closePinnedMenu(headerMenu);
        }
      });
  }, 350);
}, true);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('header-menu').forEach(closePinnedMenu);
});

function restorePinnedMenus() {
  document.querySelectorAll(`header-menu .menu-list__list-item[${PINNED_ATTRIBUTE}]`).forEach((item) => {
    const headerMenu = item.closest('header-menu');
    const trigger = item.querySelector(':scope > .menu-list__trigger > button[aria-controls]');
    const submenu = item.querySelector(':scope > .menu-list__submenu');
    if (headerMenu instanceof HTMLElement && trigger instanceof HTMLElement && submenu instanceof HTMLElement) {
      keepPinnedMenuOpen(headerMenu, item, trigger, submenu);
    }
  });
}

window.addEventListener(
  'scroll',
  () => {
    restorePinnedMenus();
    requestAnimationFrame(restorePinnedMenus);
    setTimeout(restorePinnedMenus, 100);
    setTimeout(restorePinnedMenus, 300);
  },
  { passive: true }
);
